// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'appsnapshots'

/**
 * AppSnapshot Model Interface (auto-generated from Drizzle schema)
 */
export interface AppSnapshotModel {
  id: string
  orgId: string
  workspaceId?: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  capturedBy: string
  capturedAt: string
  appId: string
  snapshotType: string
  name: string
  period: string
  periodType: string
  notes?: string
  summary: Record<string, unknown>
  data: Record<string, unknown>
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "capturedBy": {
          "type": "string",
          "maxLength": 200
      },
      "capturedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "appId": {
          "type": "string",
          "maxLength": 100
      },
      "snapshotType": {
          "type": "string",
          "maxLength": 200
      },
      "name": {
          "type": "string",
          "maxLength": 500
      },
      "period": {
          "type": "string",
          "maxLength": 200
      },
      "periodType": {
          "type": "string",
          "maxLength": 200
      },
      "notes": {
          "type": "string",
          "maxLength": 5000
      },
      "summary": {
          "type": "object"
      },
      "data": {
          "type": "object"
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "capturedBy",
      "capturedAt",
      "appId",
      "snapshotType",
      "name",
      "period",
      "periodType",
      "summary",
      "data"
  ],
  indexes: [
      [
          "orgId",
          "appId",
          "capturedAt"
      ],
      [
          "orgId",
          "appId",
          "snapshotType",
          "capturedAt"
      ],
      [
          "orgId",
          "periodType"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
